/**
 * 路由变化时的统一操作
 * **/
import router from 'router';
import store from 'store';
import { Message } from 'element-ui';
import Cookies from "js-cookie";
import { localStorageUtil, debounce, SloganContent } from "utils/util";

let cookieOpen = CookieEnable();

/**
 * 百度统计事件添加
 * 
 */
let TrackEvent = debounce(function(to) {
  let { path, query } = to;
  let userInfo = localStorageUtil.getItem('userInfo');
  if(userInfo && userInfo.customerId && window._hmt && path) {
    let _p = 0; // 1--首页 2--同步课程  3--专题课程  4--试卷库  5--我的任务 
    if(path.indexOf('/home-page') !== -1) {
      _p = 1;
    }else if(path.indexOf('/synchronous-courses') !== -1 || path.indexOf('/play') !== -1) {
      _p = 2;
    }else if(path.indexOf('/topic-classes') !== -1 || (path.indexOf('/resource-detail') !== -1 && query.type === 'topic')) {
      _p = 3;
    }else if(path.indexOf('/examination') !== -1 || (path.indexOf('/resource-detail') !== -1 && query.type === 'examination')) {
      _p = 4;
    }else if(path.indexOf('/my-task/list') !== -1) {
      _p = 5;
    }
    if(_p) {
      window._hmt.push(['_trackEvent', `p_${_p}_${userInfo.customerId}`, 'page', '']);
      // window._hmt.push(['_setCustomVar', 1, 'customer', `p_${_p}_${userInfo.customerId}`, 3]);
      console.log(`p_${_p}_${userInfo.customerId}`);
    }
  }
}, 500, false);

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 小山云课';
  } else {
    document.title = 'Student Client';
  }
  if($('#pageSlogan')[0]) {
    $('#pageSlogan').html(SloganContent(to.fullPath));
  }
  if (!cookieOpen && to.path !== '/home-page') {
    Message.error("对不起，您的浏览器的Cookie功能被禁用，请开启");
    router.push('/home-page');
    return next();
  }
  if(!Cookies.get('mvr_student_Token') && to.path !== '/home-page' && to.meta.needToken) {
    store.commit('LOGOUT', null);
    router.push('/home-page');
    return next();
  }
  TrackEvent(to);
  next();
});
/**
 * 获取当前浏览器的cookie是否开启
 * 
 */
function CookieEnable() {
  var result = false;
  if (navigator.cookiesEnabled) {
    return true;
  };

  document.cookie = "testcookie=yes;";

  var cookieSet = document.cookie;

  if (cookieSet.indexOf("testcookie=yes") > -1) {
    let date = new Date();
    date.setTime(date.getTime() - 1);
    document.cookie = 'testcookie=yes;expires=' + date.toGMTString();
    result = true;
  }
  document.cookie = "";
  return result;
}